var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_vm._v("主办：江苏省政务服务管理办公室 版权所有")]),_c('div',[_vm._v("运行管理：江苏省政务服务管理办公室")]),_c('div',{staticClass:"put"},[_vm._v("备案序号：苏ICP备15009401号")]),_c('div',[_vm._v("网站标识：3200000098")])])
}]

export { render, staticRenderFns }